import React from 'react';

interface AppInfoModalProps {
  visible: boolean;
  onClose: () => void;
}

const AppInfoModal: React.FC<AppInfoModalProps> = ({ visible, onClose }) => {
  const appVersion = '1.0.0'; // TODO: パッケージバージョンから取得

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 glass-overlay z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="glass-panel p-6 text-white max-w-md w-full max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* アプリ情報 */}
        <div className="mb-6">
          <div className="text-lg font-bold mb-3 text-white/90">アプリ情報</div>
          <div className="text-sm text-white/70 space-y-1">
            <div>アプリ名：Sorarium</div>
            <div>バージョン：{appVersion}</div>
          </div>
        </div>

        {/* クレジット */}
        <div className="mb-6">
          <div className="text-lg font-bold mb-3 text-white/90">クレジット</div>
          <div className="text-sm text-white/70 space-y-2">
            <div className="font-semibold text-white/90">制作</div>
            <div className="ml-2 text-white/50">
              絵・プログラム・テキスト：
              <a
                href="https://ameniwa.com"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-400 hover:text-blue-300 transition-colors"
              >
                Ameniwa
              </a>
            </div>
            
            <div className="font-semibold text-white/90 mt-3">素材提供</div>
            <div className="ml-2 text-white/50">
              背景素材：
              <a
                href="https://min-chi.material.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-400 hover:text-blue-300 transition-colors"
              >
                みんちりえ
              </a>
            </div>
            <div className="ml-2 text-white/50">
              アイコン素材：
              <a
                href="https://dot-illust.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-400 hover:text-blue-300 transition-colors"
              >
                DOT ILLUST
              </a>
            </div>
            <div className="ml-2 text-white/50">
              効果音：
              <a
                href="https://soundeffect-lab.info/"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-400 hover:text-blue-300 transition-colors"
              >
                効果音ラボ
              </a>
            </div>
          </div>
        </div>

        {/* その他の情報 */}
        <div>
          <div className="text-lg font-bold mb-3 text-white/90">その他</div>
          <div className="text-sm text-white/70 space-y-1">
            <div>© 2024 Ameniwa</div>
            <div className="text-xs text-white/50 mt-3">
              このアプリはポモドーロテクニックを使用した
              学習支援アプリです。
            </div>
          </div>
        </div>

        {/* 閉じるボタン */}
        <button
          onClick={onClose}
          className="mt-6 w-full py-2 px-4 glass-btn-primary transition-colors"
        >
          閉じる
        </button>
      </div>
    </div>
  );
};

export default AppInfoModal;